<template>
  <div class="center-content">
    <div class="hint-container">
      <h1>Indice n°{{ hintIndex }}</h1>
      <div class="close" @click="$emit('close')">❌</div>
      <p v-if="displayContent">
        <span v-html="innerText"></span>
      </p>
      <div v-if="!displayContent">
        <p>{{ warningMessage }}</p>
        <div class="button-wrapper">
          <button class="green" @click="confirm()">Oui</button>
          <button class="red" @click="$emit('close')">Non</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hint",
  props: {
    content: String,
    warning: { type: String, default: "Lire cet indice ?" },
    read: { type: Boolean, default: false },
    index: { type: Number, default: 1 },
  },
  data() {
    return {
      innerText: this.content,
      warningMessage: this.warning,
      hintIndex: this.index + 1,
      displayContent: this.read,
    };
  },
  methods: {
    confirm() {
      this.$emit("continue");
      this.displayContent = true;
    },
  },
};
</script>

<style scoped>
.center-content {
  width: 100%;
  display: flex;
  justify-content: center;
}
.hint-container {
  background: rgb(220, 220, 220);
  padding: 5px 20px;
  overflow: scroll;
  position: absolute;
  height: auto;
  width: auto;
  z-index: 999 !important;
  top: 20px;
  max-width: 50vw;
  min-width: 40vw;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
.button-wrapper {
  display: flex;
  justify-content: space-evenly;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  line-height: 30px;
}
.button-wrapper button {
  height: 20%;
  font-family: "VT323", monospace;
  font-size: 170%;
  border: none;
  font-weight: bold;
  padding: 1% 3%;
  background: none;
}
.button-wrapper button:hover {
  cursor: pointer;
}
.button-wrapper button:focus {
  outline: none;
}
.green:hover {
  color: green;
}
.red:hover {
  color: #ce322c;
}
</style>
